import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListCrewMembers = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  display: inline-block;
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
`;

export default ChannelListCrewMembers;
